import * as React from 'react';

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    fill="none"
    viewBox="0 0 24 25"
  >
    <circle
      cx="12"
      cy="12.5"
      r="12"
      fill="#fff"
      className="info-circle-svg"
    ></circle>
    <path
      fill="#0A77FF"
      d="M12 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2M11 17h2v-6h-2z"
      className="path-svg"
    ></path>
  </svg>
);

export default SvgIcon;
